import React, { useState, useEffect, useRef } from "react";
import { Resizable } from "./Resizable/styles";
import { useResize } from "./Resizable/useResize";
import useWindowSize from "../Hooks/windowSize";
import { ReactComponent as Download } from "../../assets/img/download.svg";
import { ReactComponent as LineWithIcon } from "../../assets/img/line_with_black.svg";
import { ReactComponent as LeftLineRedIcon } from "../../assets/img/left_red_icon.svg";
import { ReactComponent as RightLineRedIcon } from "../../assets/img/right_red_icon.svg";
import { ReactComponent as LeftLineBlackIcon } from "../../assets/img/left_black_icon.svg";
import { ReactComponent as LineWithRedIcon } from "../../assets/img/line_with_red_icon.svg";
import { ReactComponent as RightLineBlackIcon } from "../../assets/img/right_black_icon.svg";
import { educator } from "../../assets/text/educator";

const EducatorDetailEnglish = ({ width, height }) => {
  // const [width, height] = useWindowSize();
  const [arabicWidth, setArabicWidth] = useState("50%");
  const [ResizeIcon, setResizeIcon] = useState(LineWithIcon);

  const ref = React.useRef();
  const options = {
    step: 10,
    axis: "horizontal",
  };
  const { initResize, size, cursor } = useResize(ref, options);

  const handleArabicWidth = () => {
    function percentage(num, per) {
      return (num / 100) * per;
    }
    let navbarPercentage = 3 * percentage(2, width);
    setArabicWidth(width - size.width - navbarPercentage);
  };
  useEffect(() => {
    handleArabicWidth();
  }, [size.width]);

  const englishHeaderRef = useRef(null);
  const arabicHeaderRef = useRef(null);
  const englishTextRef = useRef(null);
  const arabicTextRef = useRef(null);

  useEffect(() => {
    if (width > 1124) {
      const offsetTop = window.getComputedStyle(
        englishHeaderRef.current
      ).height;
      englishTextRef.current.style.height = `calc(${
        height - 129 - 95
      }px - ${offsetTop})`;
    }
  }, [englishHeaderRef, englishTextRef, width, height]);
  useEffect(() => {
    if (width > 1124) {
      const offsetTop = window.getComputedStyle(arabicHeaderRef.current).height;
      arabicTextRef.current.style.height = `calc(${
        height - 129 - 95
      }px - ${offsetTop})`;
    }
  }, [arabicHeaderRef, arabicTextRef, width, height]);

  return (
    <>
      <Resizable ref={ref}>
        <div
          className="educator-detail-english"
          style={{
            width: size.width,
            display:
              size.width === Infinity ? "visible" : size.width < 220 && "none",
          }}
        >
          <div
            className="educator-detail-english-header"
            ref={englishHeaderRef}
          >
            <div className="educator-detail-english-name">
              educator’s <br />
              kit
            </div>
            <a
              href="pdf/educator_english.pdf"
              download
              className="educator-detail-english-download"
            >
              download english pdf
              <Download
                style={{ height: "20px", marginLeft: "8px", paddingTop: "3px" }}
              />
            </a>
          </div>
          <p className="educator-detail-english-text" ref={englishTextRef}>
            {educator.english.text.map((text, textIndex) => {
              let parts = text.split(/\*\*/g);
              return (
                <div className="educator-detail-break">
                  {parts.map((part, partIndex) => {
                    if (partIndex % 2 === 0 && part) {
                      return (
                        <span
                          className="educator-detail-english-text"
                          key={partIndex}
                        >
                          {part}
                        </span>
                      );
                    } else if (part) {
                      return (
                        <span
                          className="educator-detail-english-heading"
                          key={partIndex}
                        >
                          {part}
                        </span>
                      );
                    }
                  })}
                </div>
              );
            })}
          </p>
        </div>
      </Resizable>
      <div className="educator-detail-div">
        <ResizeIcon
          className="educator-detail-div-icon"
          cursor={cursor}
          onMouseDown={(event) => {
            initResize(event);
          }}
          onMouseEnter={() =>
            setResizeIcon(
              arabicWidth === -Infinity || size.width === Infinity
                ? LineWithRedIcon
                : arabicWidth < 80
                ? LeftLineRedIcon
                : size.width < 80
                ? RightLineRedIcon
                : LineWithRedIcon
            )
          }
          onMouseLeave={() => {
            setResizeIcon(
              arabicWidth === -Infinity || size.width === Infinity
                ? LineWithIcon
                : arabicWidth < 80
                ? LeftLineBlackIcon
                : size.width < 80
                ? RightLineBlackIcon
                : LineWithIcon
            );
          }}
        />
      </div>
      <div
        className="educator-detail-arabic"
        style={{
          display:
            arabicWidth === -Infinity ? "visible" : arabicWidth < 200 && "none",
          width: arabicWidth,
        }}
      >
        <div className="educator-detail-arabic-header" ref={arabicHeaderRef}>
          <div className="educator-detail-arabic-name">
            أدوات <br />
            التعليــــــــــــم
          </div>
          <a
            href="pdf/educator_arabic.pdf"
            download
            className="educator-detail-arabic-download"
          >
            عربي pdf تحميل
            <Download
              style={{ height: "20px", marginRight: "8px", paddingTop: "3px" }}
            />
          </a>
        </div>
        <p className="educator-detail-arabic-text" ref={arabicTextRef}>
          {educator.arabic.text.map((text, textIndex) => {
            let parts = text.split(/\*\*/g);
            return (
              <div className="educator-detail-break">
                {parts.map((part, partIndex) => {
                  if (partIndex % 2 === 0 && part) {
                    return (
                      <span
                        className="educator-detail-arabic-text"
                        key={partIndex}
                      >
                        {part}
                      </span>
                    );
                  } else if (part) {
                    return (
                      <span
                        className="educator-detail-arabic-heading"
                        key={partIndex}
                      >
                        {part}
                      </span>
                    );
                  }
                })}
              </div>
            );
          })}
        </p>
      </div>
    </>
  );
};

export default EducatorDetailEnglish;
